import React from "react"
import { Drawer as DrawerPrimitive } from "@base-ui/react/drawer"
import { Button } from "../button"
import { Icon } from "../icon"
import { VisuallyHidden } from "../visually-hidden"

export type DrawerCloseProps = {
  children?: React.ReactNode
  className?: string
  disabled?: boolean
  render?: React.ReactElement
}

const defaultContent = (
  <>
    <Icon name="close" />
    <VisuallyHidden>Close drawer</VisuallyHidden>
  </>
)

/**
 * A button that dismisses the drawer.
 */
export function DrawerClose({
  children,
  className,
  disabled,
  render
}: DrawerCloseProps) {
  return (
    <DrawerPrimitive.Close
      data-slot="drawer-close"
      className={className}
      disabled={disabled}
      render={render ?? <Button variant="tertiary" />}
    >
      {children ?? defaultContent}
    </DrawerPrimitive.Close>
  )
}

DrawerClose.displayName = "Drawer.Close"
